import React, { useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { useNavigate } from "react-router-dom";
import sajana from "../../assets/images/profile/sajana-profile.png";
import userProfile from "../../assets/images/profile/profile.png";
import { saveIngredientCheckerApi } from "../../services/ingredientChecker.service";
import ReactGA from "react-ga4";
import { set } from "lodash";

interface IngredientCheckerComponentInterface {
  data: any;
}
const { TextArea } = Input;

const IngredientCheckerComponent: React.FC<
  IngredientCheckerComponentInterface
> = ({ data }) => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [form] = Form.useForm();
  const [inputValue, setInputValue] = useState("");
  const [response, setResponse] = useState(data || null);

  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.profile);
  const { first_name, survey_id } = profile;
  const navigate = useNavigate();

  return (
    <section className="store-section ingredient-checker-component ingredient-checker">
      <Card>
        <div className="ingredient-checker__header">
          <img src={userProfile} alt="Profile" />
          <h1
            className="tracker-title store-card__title"
            style={{ marginBottom: 0 }}
          >
            Ask Sky - What’s in your product?
          </h1>
        </div>
        <div className="bg">
          {!submitted ? (
            <Form
              form={form}
              onFinish={(values) => {
                setLoading(true);
                const data = {
                  survey_id: survey_id,
                  prompt: values.prompt || "",
                };
                dispatch(
                  saveIngredientCheckerApi({
                    data,
                    finalCallback: () => {
                      setLoading(false);
                      form.resetFields();
                      setInputValue("");
                    },
                    successCallback: (response: any) => {
                      setResponse(response?.data?.response);
                      setSubmitted(true);
                    },
                    failureCallback: () => {
                      setLoading(false);
                      setError(true);
                    },
                  })
                );
              }}
            >
              <Form.Item
                name="prompt"
                rules={[
                  { required: true, message: "Please provide your feedback." },
                ]}
              >
                <div className="ingredient-checker__placeholder">
                  {/* Custom styled placeholder */}
                  {!inputValue && (
                    <div className="ingredient-checker__placeholder-value">
                      <p className="placeholder-title">
                        Hi! I’m Sky, your virtual ai ingredient decoder ☁️.
                      </p>
                      <p className="placeholder-des">
                        Paste your full ingredient list here, and I’ll help
                        explain what’s in your product using simple language.
                      </p>
                    </div>
                  )}

                  <TextArea
                    rows={6}
                    maxLength={600}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                </div>
              </Form.Item>

              <div className="submit-btn-holder">
                <Button
                  htmlType="submit"
                  className="submit-btn ant-btn btn-primary ingre"
                  loading={loading}
                >
                  Explain Ingredients
                </Button>
              </div>
            </Form>
          ) : (
            <div>
              <div
                className="msg content ingredient-checker-msg"
                dangerouslySetInnerHTML={{ __html: response }}
              ></div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <Button
                  className="btn-primary cta-btn"
                  onClick={() => {
                    setSubmitted(false);
                    setResponse(null);
                    form.resetFields();
                    setInputValue("");
                  }}
                >
                  Check Another Product
                </Button>
              </div>
            </div>
          )}
        </div>
      </Card>

      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/skincare-steps");
            ReactGA.event({
              category: "Store",
              action: `Go to Holistic Care button clicked`,
              label: "",
              nonInteraction: true,
              transport: "xhr",
            });
          }}
        >
          Go to Skincare Steps
        </Button>
      </div>
    </section>
  );
};

export default IngredientCheckerComponent;
